"use strict";
/*
 * Created on 15. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractReleaseTotalDTO_1 = require("../AbstractReleaseTotalDTO");
/**
 * DTO object for sellout release "Total detail" tab. Object represents one product category of sellout release
 * and aggregated values for this category. Categories that correspond to the release parts have also associated
 * workflow status available.
 *
 * @author Radek Beran
 */


var SelloutReleaseTotalDTO =
/*#__PURE__*/
function (_AbstractReleaseTotal) {
  _inherits(SelloutReleaseTotalDTO, _AbstractReleaseTotal);

  /**
   * Constructs new sellout release "Total" info object.
   * @param categoryId id of category
   * @param impact sellout impact record for the category
   * @param approvalStatus approval status is filled in case this is ROOT category (approval data for the whole release)
   * or release-part category (approval data for part of release)
   * @param actionFeasibilities feasibilities of workflow actions
   * @param targets specified target attributes for the category; or null if not available
   */
  function SelloutReleaseTotalDTO(categoryId, impact, previousImpacts, approvalStatus, actionFeasibilities, realImpact, targets) {
    var _this;

    _classCallCheck(this, SelloutReleaseTotalDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseTotalDTO).call(this, categoryId, approvalStatus, actionFeasibilities, realImpact));
    _this.categoryId = categoryId;
    _this.impact = impact;
    _this.previousImpacts = previousImpacts;
    _this.approvalStatus = approvalStatus;
    _this.actionFeasibilities = actionFeasibilities;
    _this.realImpact = realImpact;
    _this.targets = targets;
    return _this;
  }

  return SelloutReleaseTotalDTO;
}(AbstractReleaseTotalDTO_1.AbstractReleaseTotalDTO);

exports.SelloutReleaseTotalDTO = SelloutReleaseTotalDTO;